export var AuditEventType;
(function (AuditEventType) {
    AuditEventType["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
    AuditEventType["LOGIN_FAILURE"] = "LOGIN_FAILURE";
    AuditEventType["LOGOUT"] = "LOGOUT";
    AuditEventType["MFA_CHALLENGE"] = "MFA_CHALLENGE";
    AuditEventType["TOKEN_REFRESH"] = "TOKEN_REFRESH";
    AuditEventType["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    AuditEventType["PAGE_VIEW"] = "PAGE_VIEW";
    AuditEventType["RECORD_VIEWED"] = "RECORD_VIEWED";
    AuditEventType["RECORD_CREATED"] = "RECORD_CREATED";
    AuditEventType["RECORD_UPDATED"] = "RECORD_UPDATED";
    AuditEventType["RECORD_DELETED"] = "RECORD_DELETED";
    AuditEventType["SENSITIVE_REVEALED"] = "SENSITIVE_REVEALED";
    AuditEventType["DOCUMENT_UPLOADED"] = "DOCUMENT_UPLOADED";
    AuditEventType["DOCUMENT_DOWNLOADED"] = "DOCUMENT_DOWNLOADED";
    AuditEventType["DOCUMENT_DELETED"] = "DOCUMENT_DELETED";
    AuditEventType["DOCUMENT_EXPIRY_ALERT"] = "DOCUMENT_EXPIRY_ALERT";
    AuditEventType["SALARY_VIEWED"] = "SALARY_VIEWED";
    AuditEventType["SALARY_UPDATED"] = "SALARY_UPDATED";
    AuditEventType["BULK_SALARY_VIEW"] = "BULK_SALARY_VIEW";
    AuditEventType["PAYROLL_EXPORT"] = "PAYROLL_EXPORT";
    AuditEventType["LEAVE_APPLIED"] = "LEAVE_APPLIED";
    AuditEventType["LEAVE_APPROVED"] = "LEAVE_APPROVED";
    AuditEventType["LEAVE_REJECTED"] = "LEAVE_REJECTED";
    AuditEventType["TIMESHEET_SUBMITTED"] = "TIMESHEET_SUBMITTED";
    AuditEventType["TIMESHEET_APPROVED"] = "TIMESHEET_APPROVED";
    AuditEventType["ATTENDANCE_CHECKIN"] = "ATTENDANCE_CHECKIN";
    AuditEventType["ATTENDANCE_CHECKOUT"] = "ATTENDANCE_CHECKOUT";
    AuditEventType["ATTENDANCE_OVERRIDE"] = "ATTENDANCE_OVERRIDE";
    AuditEventType["EXPENSE_SUBMITTED"] = "EXPENSE_SUBMITTED";
    AuditEventType["EXPENSE_APPROVED"] = "EXPENSE_APPROVED";
    AuditEventType["EXPENSE_REJECTED"] = "EXPENSE_REJECTED";
    AuditEventType["ASSET_ASSIGNED"] = "ASSET_ASSIGNED";
    AuditEventType["ASSET_RETURNED"] = "ASSET_RETURNED";
    AuditEventType["ONBOARDING_STARTED"] = "ONBOARDING_STARTED";
    AuditEventType["ONBOARDING_COMPLETED"] = "ONBOARDING_COMPLETED";
    AuditEventType["OFFBOARDING_INITIATED"] = "OFFBOARDING_INITIATED";
    AuditEventType["PROBATION_PASSED"] = "PROBATION_PASSED";
    AuditEventType["PROBATION_EXTENDED"] = "PROBATION_EXTENDED";
    AuditEventType["PROBATION_FAILED"] = "PROBATION_FAILED";
    AuditEventType["GRIEVANCE_FILED"] = "GRIEVANCE_FILED";
    AuditEventType["GRIEVANCE_ACCESSED"] = "GRIEVANCE_ACCESSED";
    AuditEventType["GRIEVANCE_RESOLVED"] = "GRIEVANCE_RESOLVED";
    AuditEventType["PERFORMANCE_REVIEW_CREATED"] = "PERFORMANCE_REVIEW_CREATED";
    AuditEventType["PIP_INITIATED"] = "PIP_INITIATED";
    AuditEventType["ROLE_CHANGED"] = "ROLE_CHANGED";
    AuditEventType["PERMISSION_CHANGED"] = "PERMISSION_CHANGED";
    AuditEventType["EXPORT_GENERATED"] = "EXPORT_GENERATED";
    AuditEventType["REPORT_VIEWED"] = "REPORT_VIEWED";
    AuditEventType["ADMIN_ACTION"] = "ADMIN_ACTION";
    AuditEventType["INTEGRATION_SYNC"] = "INTEGRATION_SYNC";
    AuditEventType["WEBHOOK_RECEIVED"] = "WEBHOOK_RECEIVED";
    AuditEventType["ANOMALY_DETECTED"] = "ANOMALY_DETECTED";
})(AuditEventType || (AuditEventType = {}));
//# sourceMappingURL=audit.js.map